import API from "./index";

class DocumentoIBPService {
  constructor() {
    this.path = `api/documento-ibp`;
  }


  findById(id) {
    return API.get(`${this.path}/findById/${id}`);

  }

  deletar(id) {
    return API.delete(`${this.path}/deletar/${id}`);
  }



  salvar(entity) {
    return API.post(`${this.path}/salvar`, entity);

  }

  editar(entity) {
    return API.put(`${this.path}/editar`, entity);

  }

  atualizarSituacao(situacao, id) {
    return API.put(`${this.path}/atualizarSituacao/${situacao}/${id}`);

  }

}

export default DocumentoIBPService;
